import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { CardAccountStackRoutes, CardAccountStackScreenProps } from '../../card.navigator';
import { CreateCardAccountMain } from './CreateCardAccountMain';
import { CreateCardAccountIndividual } from './CreateCardAccountIndividual';
import { CreateCardAccountDocument } from './CreateCardAccountDocument';
import { CreateCardAccountConfirm } from './CreateCardAccountConfirm';
import { CreateCardAccountPlaced } from './CreateCardAccountPlaced';
import { SelectAccountScreen } from './SelectAccount.screen';
import { SelectCardAccountScreen } from './SelectCardAccount.screen';

import { CreateCardAccountStackParamList, CreateCardAccountStackRoutes } from './type';
import { ModalContainerView } from '@/features/account-management/components/ModalContainerView';

const CreateCardAccountStack = createNativeStackNavigator<CreateCardAccountStackParamList>();

export const CreateCardAccountNavigator: React.FC<CardAccountStackScreenProps<CardAccountStackRoutes.CreateCardAccount>> = ({ route }) => {
  const { func, refresh, onChangeView, onSelect, onBackData, borderRadiusFlag } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <CreateCardAccountStack.Navigator
          initialRouteName={CreateCardAccountStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.Main}
            component={CreateCardAccountMain}
            initialParams={{ onLayout, onData, func, onReturnData, refresh }}
            options={{ headerShown: false }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.Individual}
            component={CreateCardAccountIndividual}
            initialParams={{ onLayout, data, onData, func, onReturnData, refresh, onChangeView, onBackData }}
            options={{
              presentation: layout.isMobile ? 'modal' : 'transparentModal',
              headerShown: false
            }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.Document}
            component={CreateCardAccountDocument}
            initialParams={{ onLayout, data, onData, func, onReturnData, refresh, onChangeView }}
            options={{
              presentation: layout.isMobile ? 'modal' : 'transparentModal',
              headerShown: false
            }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.Confirm}
            component={CreateCardAccountConfirm}
            initialParams={{ onLayout, func, data, onReturnData, refresh, onChangeView }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.Placed}
            component={CreateCardAccountPlaced}
            initialParams={{ onLayout, data, returnData, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.SelectAccount}
            component={SelectAccountScreen}
            initialParams={{ onLayout, onSelect, onChangeView, borderRadiusFlag }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
          <CreateCardAccountStack.Screen
            name={CreateCardAccountStackRoutes.SelectCardAccount}
            component={SelectCardAccountScreen}
            initialParams={{ onLayout, onSelect, onChangeView, borderRadiusFlag }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </CreateCardAccountStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
